export const getWebUrl = () =>
    typeof window !== undefined ? window.location.href : '';


export const getGAClientId = () => {
    try {
        const tracker = window.ga.getAll()[0];
        return tracker.get('clientId');
    } catch (e) {
        return '';
    }
};

export const getUTMParameters = () => {
    const params = getQueryParams();
    const utms = {
        utm_campaign: params['utm_campaign'] || '',
        utm_source: params['utm_source'] || '',
        utm_medium: params['utm_medium'] || '',
        utm_term: params['utm_term'] || '',
        utm_content: params['utm_content'] || ''
    };
    return utms;
};

/**
 * Grabs the search string from the url and returns
 * an Object of all the parameters
 * @return {Object} queryParams
 */
export const getQueryParams = () => {
    try {
        const query = window.location.search;
        return formatQueryParams(query);
    } catch (e) {
        return {};
    }
};

/**ds
 * Takes a search string and returns object of query parameters
 * Always returns an object
 * @param {string} searchString
 * @return {Object}
 */
export const formatQueryParams = searchString => {
    if (
        !searchString ||
        typeof searchString !== 'string' ||
        !searchString.length
    ) {
        return {};
    }

    if (searchString[0] !== '?') {
        return {};
    }

    return searchString
        .substr(1)
        .split('&')
        .map(pair => {
            let keyValue = pair.split('=');
            if (keyValue.length === 2) {
                return {
                    [keyValue[0]]: decodeURIComponent(keyValue[1])
                };
            }
            return {};
        })
        .reduce((obj, value) => ({ ...obj, ...value }), {});
};

export default { getWebUrl, getGAClientId, getUTMParameters };


// WEBPACK FOOTER //
// ./src/utils/pageScrapers.js